import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import ReportRangeSelector from 'scoreboard/components/calendar-range-selector'
import SelectReportStacksForm from '../common/select-report-stacks-form'
import template from './red-metrics-new.hbs'


var RedMetricsNew = Backbone.View.extend({

	className: 'reports red-metrics margin-collapse',

	events: {
		'change .showAbbreviatedValues' : '_onChangeAbbreviatedValues'
	},

	initialize: function(options) {
		this.options = options
		this.stacksForm = new SelectReportStacksForm(_.pick(this, ['el', 'model']))

		this.filters = this.model.attributes.filters

		this.repeatByStack = _.find(this.model.stacks().models,
			stack => { return stack.has('repeatBy') })

		this.range = this.repeatByStack ? this.repeatByStack.get('repeatBy').timeRange() : defaultRange()
		this.rangeSelector = new ReportRangeSelector(
			_.defaults({canChangeCalendar: true}, { range: this.range }))

		//ensure range is set if it wasn't before
		this._applySelector()

		//apply selector changes to model
		this.listenTo(this.rangeSelector, 'change', this._applySelector)

		// Set real, column properties from fake, structure property provided by as a
		// default value
		this.model.setAbbreviateValues(this.model.get('showAbbreviatedValues'))
	},

	render: function() {
		this.$el.html(template())
		this.stacksForm.render()
		this.rangeSelector.setElement(this.$('.toggler-rows')).render()
		return this
	},

	_applySelector: function() {
		let range = this.rangeSelector.val()
		_.set(this.filters, 'colors[0].range', range)
		_.extend(this.range, range)  //set stack range, via object reference
	},

	_onChangeAbbreviatedValues(e) {
		let enable = !!$(e.target).prop('checked')
		this.model.setAbbreviateValues(enable)
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.rangeSelector, this.stacksForm], 'remove')
	}

})

export default RedMetricsNew

RedMetricsNew.__filename__ = 'reports/wizard/red-metrics/red-metrics-new.js'
